/**
 * The BricklinkUpdateDialog state slice.
 *
 * Two pages render the same dialog — User Inventory (after a percentage
 * reprice) and Inventory Audit (after a remediation preflight that recommends
 * BrickLink's own mass update) — and the dialog reads its state under the page
 * name it was handed. One schema, spread into both page schemas, so the two
 * copies cannot drift.
 */
export const bricklinkUpdateDialogStateSchema = {
    type: 'object',
    properties: {
        isOpen: { type: 'boolean', default: false },
        session: {
            type: 'object',
            properties: {
                itemCount: { type: 'number', default: 0 },
                skippedItems: {
                    type: 'array',
                    items: { type: 'object' },
                    default: []
                },
                failedItems: {
                    type: 'array',
                    items: { type: 'object' },
                    default: []
                },
                snippets: {
                    type: 'array',
                    items: {
                        type: 'object',
                        properties: {
                            sequence: { type: 'number' },
                            itemCount: { type: 'number' },
                            byteCount: { type: 'number' },
                            xml: { type: 'string' },
                            copyStatus: { type: 'string' },
                            copyError: { type: ['string', 'null'] }
                        }
                    },
                    default: []
                },
                syncItemIds: {
                    type: 'array',
                    items: { type: 'number' },
                    default: []
                },
                syncStatus: { type: 'string', default: 'not_applicable' },
                syncResult: {
                    type: ['object', 'null'],
                    default: null
                },
                syncError: { type: ['string', 'null'], default: null },
                job_id: { type: ['string', 'null'], default: null },
                status_url: { type: ['string', 'null'], default: null },
                monitorStatus: { type: 'string', default: 'idle' }
            }
        }
    }
};

export default bricklinkUpdateDialogStateSchema;
